import { ArrowUpRight, Smartphone, Instagram, Music2, MessageCircle, Star, Zap, Facebook, CreditCard } from "lucide-react";
import { SITE } from "@/lib/site";

export default function CrossSell() {
  return (
    <section id="in7" data-testid="crosssell-section" className="relative py-20 lg:py-28 border-t border-black/[0.05]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2b2620]">Das vollständige System</div>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#2b2620]">
            Bestehende Bewertungen managen.<br />
            <span className="gold-text">Neue Bewertungen aktiv einsammeln.</span>
          </h2>
          <p className="mt-5 text-[#6b5f52] leading-relaxed">
            Problematische Bewertungen professionell zu managen ist ein wichtiger Teil des digitalen Reputationsschutzes. Genauso wichtig ist die andere Seite: neue, ehrliche Bewertungen aktiv einsammeln – im Moment der Zufriedenheit, direkt vor Ort.
          </p>
        </div>

        {/* in7sekunden card */}
        <div className="mt-14 grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="lg:col-span-3 relative overflow-hidden rounded-3xl border border-[#2b2620]/30 bg-gradient-to-br from-[#fafbfd] via-[#ffffff] to-[#f5f1ea] p-8 lg:p-12 group">
            <div className="absolute -top-32 -right-24 w-[400px] h-[400px] rounded-full bg-[#2b2620]/15 blur-[120px]" />
            <div className="relative">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#2b2620]/40 bg-[#2b2620]/10 text-[#2b2620] text-xs font-semibold uppercase tracking-[0.18em]">
                <Zap className="w-3.5 h-3.5" /> Schwesterlösung
              </div>
              <h3 className="mt-6 font-heading text-3xl sm:text-4xl font-semibold text-[#2b2620] tracking-tight">
                in7sekunden.de
              </h3>
              <p className="mt-3 text-lg text-[#4a3f36]">
                Mehr Bewertungen &amp; Follower. <span className="gold-text font-medium">In 7 Sekunden.</span>
              </p>
              <p className="mt-5 text-sm text-[#6b5f52] leading-relaxed max-w-xl">
                Mit einem NFC-Aufsteller führen Sie Kunden direkt zur Bewertung, zu Instagram, TikTok, WhatsApp, Ihrem Wunschlink – oder zur schnellen Zahlung. Ein Tap. Kein Suchen. Kein Tippen.
              </p>

              <div className="mt-7 grid grid-cols-3 sm:grid-cols-6 gap-3">
                {[
                  { icon: Star, label: "Google" },
                  { icon: Instagram, label: "Instagram" },
                  { icon: Facebook, label: "Facebook" },
                  { icon: Music2, label: "TikTok" },
                  { icon: MessageCircle, label: "WhatsApp" },
                  { icon: CreditCard, label: "PayPal" },
                ].map(({ icon: Icon, label }) => (
                  <div key={label} className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-black/[0.03] border border-black/[0.08]">
                    <Icon className="w-4 h-4 text-[#2b2620]" />
                    <span className="text-xs text-[#3a3128] font-medium">{label}</span>
                  </div>
                ))}
              </div>

              <a
                href={SITE.sister.in7}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="in7-cta"
                className="mt-8 inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#2b2620] text-white font-semibold hover:bg-[#4a4038] transition-colors group"
              >
                Zum Bewertungssystem in 7 Sekunden
                <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-2 relative overflow-hidden rounded-3xl border border-black/[0.08] bg-[#faf6ef] p-8 lg:p-10">
            <div className="w-12 h-12 rounded-xl bg-[#2b2620]/10 border border-[#2b2620]/30 flex items-center justify-center text-[#2b2620]">
              <Smartphone className="w-6 h-6" />
            </div>
            <h3 className="mt-6 font-heading text-2xl font-semibold text-[#2b2620] tracking-tight">
              Ein Tap. Kein Tippen. Keine Umwege.
            </h3>
            <p className="mt-3 text-sm text-[#6b5f52] leading-relaxed">
              Viele zufriedene Kunden bewerten nicht — nicht aus Unzufriedenheit, sondern weil der Moment vergeht. Der NFC-Aufsteller schließt genau diese Lücke.
            </p>
            <div className="mt-6 flex items-center gap-3 text-sm text-[#4a3f36]">
              <span className="w-1.5 h-1.5 rounded-full bg-[#2b2620]" /> Im Geschäft
            </div>
            <div className="mt-2 flex items-center gap-3 text-sm text-[#4a3f36]">
              <span className="w-1.5 h-1.5 rounded-full bg-[#2b2620]" /> In der Praxis
            </div>
            <div className="mt-2 flex items-center gap-3 text-sm text-[#4a3f36]">
              <span className="w-1.5 h-1.5 rounded-full bg-[#2b2620]" /> Im Restaurant &amp; Salon
            </div>
            <a
              href={SITE.sister.in7}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="in7-cta-secondary"
              className="mt-8 inline-flex w-full items-center justify-center gap-2 px-5 py-3 rounded-full border border-black/10 text-[#2b2620] hover:bg-black/[0.03] transition-colors"
            >
              NFC-Aufsteller ansehen
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* femmes link */}
        <div className="mt-6 rounded-3xl border border-black/[0.08] bg-[#faf6ef] p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center justify-between gap-5">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.18em] text-[#8a7f70]">Wenn gewünscht: Marketing &amp; Webseite</div>
            <h4 className="mt-2 font-heading text-xl font-medium text-[#2b2620]">
              Digitales Marketing, Social-Media &amp; eigene Webseite – aus einer Hand.
            </h4>
            <p className="mt-2 text-sm text-[#6b5f52]">
              Diese Leistungen erbringe ich über die Schwesterplattform <span className="text-[#3a3128]">femmesonlinebusiness.com</span>.
            </p>
          </div>
          <a
            href={SITE.sister.femmes}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="femmes-cta"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-black/10 text-[#2b2620] hover:bg-black/[0.03] transition-colors shrink-0"
          >
            Mehr erfahren <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
